/**
 * Формируем домен первого уровня для API_URL
 * @param apiUrl - публичный api url для запросов
 * @param domain - домен приложения
 */
export const getSplicedHost = (apiUrl: string, domain: string) => {
  if (!apiUrl) throw new Error(`Невалидное значание API_URL:${apiUrl}`)

  // Разбиваем строку по . для того, чтобы заменить домен 1 уровня
  const splitApiUrl = apiUrl.split('.')

  /*
    Если элементов в массиве меньше 3 - значит ссылка на сайт некорректная
    Сайт обрабатывает только ссылки с доменами 3 уровня, которые являются городами
  */

  if (splitApiUrl.length < 3)
    throw new Error(`Невалидное значение разделенного API_URL:${splitApiUrl}`)

  // Заменяем домен 1 уровня
  splitApiUrl?.splice(-1, 1, domain)

  return splitApiUrl.join('.')
}
